<app-details-wrapper
  [title]="file?.name"
  [showExpandIcon]="true"
  [showEditIcon]="false"
  [titleClass]="'tw-text-2xl xs:tw-text-xl'"
  [headerIconName]="'left-arrow'"
  [headerIconClickable]="true"
  (onHeaderIconClicked)="handleBackClick()"
  (onBackClicked)="handleBackClick()"
>
  <div class="tw-flex tw-flex-col tw-gap-3">
    <!-- File -->
    <div class="tw-rounded-xl tw-bg-color-surface-card tw-p-4">
      <p
        class="tw-m-0 tw-mb-2 tw-text-xs tw-uppercase tw-tracking-[0.03em] tw-text-dt-text-tertiary"
      >
        {{ "file" | i18n }}
      </p>
      <div class="sm:tw-w-full tw-rounded-xl tw-p-4 tw-shadow-elevation-card">
        <div
          *ngIf="file"
          class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-xl tw-border tw-border-color-border-subtle tw-bg-color-surface-elevated tw-px-4 tw-py-4 tw-shadow-card-elevated"
        >
          <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-1.5">
            <icon [name]="iconMeta.icon" [size]="5" [currentColor]="iconMeta.iconColor"></icon>
            <span class="tw-truncate tw-text-base tw-text-color-text-default">{{ file.name }}</span>
          </div>
          <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-4 tw-text-xs tw-font-medium">
            <button
              class="tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-white tw-px-3 tw-py-1.5 tw-text-dt-custom-teal-11 tw-shadow-card-elevated dark:tw-border-color-border-default"
              [disabled]="isReplaceFileLoading"
              (click)="replaceFile()"
            >
              @if (isReplaceFileLoading) {
                <svg
                  aria-hidden="true"
                  class="tw-h-4 tw-w-4 tw-animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="tw-opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="tw-opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
              } @else {
                {{ "replace" | i18n }}
              }
            </button>
            <button
              class="tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-white tw-px-3 tw-py-1.5 tw-text-dt-custom-teal-11 tw-shadow-card-elevated dark:tw-border-color-border-default"
              [disabled]="isFullPreviewLoading"
              (click)="onFullPreviewClick()"
            >
              @if (isFullPreviewLoading) {
                <svg
                  aria-hidden="true"
                  class="tw-h-4 tw-w-4 tw-animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="tw-opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="tw-opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
              } @else {
                {{ "viewFullPage" | i18n }}
              }
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Link to Accounts -->
    <div class="tw-rounded-xl tw-bg-color-surface-card tw-p-4">
      <p
        class="tw-m-0 tw-mb-2 tw-text-xs tw-uppercase tw-tracking-[0.03em] tw-text-dt-text-tertiary"
      >
        {{ "linkToAccounts" | i18n }}
      </p>
      <div
        class="tw-rounded-xl tw-bg-color-surface-card tw-px-4 tw-py-4 tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
      >
        <div
          *ngFor="let account of accounts"
          class="tw-bg-color-surface-sunken tw-rounded-lg tw-px-4 tw-py-2 tw-text-base space-y-2 tw-mb-3"
        >
          <span class="tw-font-medium">{{ account?.name }}</span>
          <div class="tw-flex tw-gap-4 tw-my-1.5">
            <div class="tw-text-dt-text-disabled tw-text-xs tw-uppercase">
              {{ "opening" | i18n }}
              <span class="tw-block tw-text-sm tw-normal-case tw-text-color-text-default">
                {{ openingBalance(account.id)?.bankImportedBalance | number: "1.2-2" }}
                {{ account?.currency }}
              </span>
            </div>
            <div class="tw-text-dt-text-disabled tw-text-xs tw-uppercase">
              {{ "closing" | i18n }}
              <span class="tw-block tw-text-sm tw-normal-case tw-text-color-text-default">
                {{ closingBalance(account.id)?.bankImportedBalance | number: "1.2-2" }}
                {{ account?.currency }}
              </span>
            </div>
          </div>
          <div
            class="tw-flex tw-justify-between tw-items-center tw-bg-color-surface-elevated tw-px-2 tw-py-1.5 tw-rounded-lg tw-text-color-text-default tw-mb-1"
          >
            <div class="tw-text-xs">
              <span class="tw-text-dt-text-secondary tw-uppercase">{{
                "transactions" | i18n
              }}</span>
              <span class="tw-font-medium"> ({{ getTransactionCount(account?.id) }}) </span>
            </div>
            <button class="tw-font-medium tw-text-xs tw-text-color-text-action">
              {{ "edit" | i18n }}
            </button>
          </div>
        </div>

        <button
          class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-xl tw-border tw-border-color-border-subtle tw-bg-color-surface-elevated tw-py-1.5 tw-text-sm tw-text-dt-custom-teal-11 tw-shadow-card-elevated"
          (click)="linkAnotherAccount()"
        >
          <icon [name]="'add'" [size]="3" [currentColor]="'dt-custom-teal-11'"></icon>
          {{ "linkAnotherAccount" | i18n }}
        </button>
      </div>
    </div>

    <!-- File Details -->
    <div class="tw-rounded-xl tw-bg-color-surface-card tw-p-4">
      <p
        class="tw-m-0 tw-mb-2 tw-text-xs tw-uppercase tw-tracking-[0.03em] tw-text-dt-text-tertiary"
      >
        {{ "fileDetails" | i18n }}
      </p>
      <div
        class="tw-rounded-xl tw-bg-color-surface-card tw-px-4 tw-py-4 tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
      >
        <app-cabinet-form
          [saveButtonOptions]="saveButtonOptions"
          [fileName]="file?.name"
          [fromDate]="file?.statementFromDate"
          [toDate]="file?.statementToDate"
          (fileNameChanged)="onFileNameChanged($event)"
          (dateRangeChanged)="onDateRangeChanged($event)"
        ></app-cabinet-form>
      </div>
    </div>

    <button
      (click)="deleteFile(dialogContent)"
      class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-2xl tw-bg-color-surface-card tw-mx-4 tw-py-3 tw-text-base tw-text-dt-text-error tw-shadow-elevation-card"
    >
      <icon [name]="'trash-bin'" [size]="4" [currentColor]="'dt-text-error'"></icon>
      {{ "deleteThisStatement" | i18n }}
    </button>
  </div>
</app-details-wrapper>

@if (showFullPreview() && previewFile) {
  <app-file-full-preview
    [file]="previewFile"
    [fileName]="file.name"
    (closed)="closeFullPreview()"
  ></app-file-full-preview>
}

<ng-template #dialogContent>
  <div class="tw-flex tw-justify-center">
    <p class="tw-text-[20px] tw-font-medium tw-text-color-text-default">
      {{ "deleteStatement" | i18n }}
    </p>
  </div>
  <div class="tw-p-2">
    <span class="tw-font-medium tw-text-color-text-default">{{
      "cabinetYoureAboutToDeleteThisStatementData" | i18n
    }}</span>
    <p class="tw-font-normal tw-text-sm">{{ "cabinetKeepDataContext" | i18n }}</p>
  </div>
</ng-template>
